import useService from '@/auth/service/useService';
import { normalizeRole, ROLES } from '@/constants/roles';
import LogRocket from '@/libs/logrocket';

export default {
  namespaced: true,
  state: {
    user: null,
    permissions: []
  },
  getters: {
    authUser: state => state.user,
    permissions: state => state.permissions,
    isAdmin: state => Array.isArray(state.user?.roles) && state.user.roles.includes(ROLES.ADMIN)
  },
  mutations: {
    SET_USER(state, val) {
      state.user = val;
    },
    SET_PERMISSIONS(state, val) {
      state.permissions = val;
    }
  },
  actions: {
    async me({ commit }) {
      try {
        const meResponse = await useService.me();

        commit('SET_PERMISSIONS', meResponse.data.permissions);

        const roles = Array.isArray(meResponse.data?.roles) ? meResponse.data.roles : [];
        const normalizedRoles = roles.map(normalizeRole).filter(Boolean);
        const user = { ...meResponse.data, roles: normalizedRoles };

        commit('SET_USER', user);

        LogRocket.identify(user.id, {
          name: user.name,
          email: user.email
        });

        return meResponse;
      } catch (err) {
        // console.log(err);
        return err;
      }
    },
    logout() {
      localStorage.removeItem(useService.serviceConfig.storageTokenKeyName);
      localStorage.removeItem(useService.serviceConfig.storageRefreshTokenKeyName);
      //  For reset all states
      window.location.href = '/';
      //  commit('SET_PERMISSIONS', []);
      //  commit('SET_USER', null);
    }
  }
};
